export default __webpack_public_path__ + "static/media/logo-no-bg.6eeca2d2.png";